export const driverConversationSelectStyles = {
  container: (base) => {
    return {
      ...base,
      width: `250px`,
      boxShadow: 'none',
    };
  },
  control: (base, state) => ({
    ...base,
    minHeight: 32,
    border: `1px solid ${state.isDisabled ? '#E2E8EE' : '#0140CD'}`,
    borderRadius: '4px',
    backgroundColor: state.isDisabled ? '#E2E8EE' : '#0140CD',
    boxShadow: 'none',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'white',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#E2E8EE' : 'white',
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    display: 'none',
    paddingTop: 0,
    paddingBottom: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: 'white',
    fontWeight: 'bold',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 10,
    textAlign: 'left',
  }),
};
